import { ScriptWrapper } from './ScriptBlock.style'
import { ITerrificBlock } from '../../../types'
import ComponentTitle from '../../ComponentTitle/ComponentTitle'

interface TerrificProps {
  data: ITerrificBlock
}

export const ScriptBlock = ({ data }: TerrificProps) => {
  return (
    <>
      {data.grid_title && <ComponentTitle componentTitle={data.grid_title} />}
      <ScriptWrapper dangerouslySetInnerHTML={{ __html: data.script }} />
    </>
  )
}
